export default {
    namespaced: true,
    state:{
        page:1,
        purchaseOrder:[]
    },
    actions:{

    },
    mutations:{
        updatePagination(state, page){
            state.page = page
        }
    }
}
